import { render } from "./YesNoModal.vue?vue&type=template&id=4ac70a37"
import script from "./YesNoModal.vue?vue&type=script&lang=js"
export * from "./YesNoModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__